import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBean: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bean, java"><path d="M19.2228 4.77723C22.414 7.96845 21.7672 13.7892 17.7782 17.7782C13.7892 21.7672 7.96845 22.414 4.77723 19.2228C1.58601 16.0315 2.23276 10.2108 6.22178 6.22178C10.2108 2.23276 16.0315 1.58601 19.2228 4.77723Z" stroke="currentColor" strokeWidth="1.5"/><path d="M4.12891 17.7498C8.24536 9.8338 15.7489 14.1629 19.8689 6.25977" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBean;
